import fs from 'fs';
import path from 'path';
import { Readable } from 'stream';
import { ReadableStream as NodeReadableStream } from 'stream/web';

export type RobotResponse = {
  success: boolean;
  error?: string;
};

export async function downloadRobot(file: string, downloadPath: string) {
  const result = await fetch(`${process.env.ROBOT_HOST}/api/llm/kb/file/${file}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(`${process.env.ROBOT_USER}:${process.env.ROBOT_PASSWORD}`)}`,
    },
  });

  if (!result.ok) {
    throw new Error(`Error while downloading file ${file} from ROBOT. Status: ${result.status} - ${result.statusText}`);
  }

  // parse filename from Content-Disposition header
  const contentDisposition = result.headers.get('content-disposition');
  const match = contentDisposition?.match(/filename="?(.+?)"?$/);
  if (!match) {
    throw new Error(`Error while parsing filename from Content-Disposition header: ${contentDisposition}`);
  }
  const filename = match[1];
  if (!filename) {
    throw new Error(`Filename is empty in Content-Disposition header: ${contentDisposition}`);
  }

  const filePath = path.join(downloadPath, filename);
  const fileStream = fs.createWriteStream(filePath);
  const resultBody = result.body as NodeReadableStream;
  if (resultBody) {
    await new Promise<void>((resolve, reject) => {
      Readable.fromWeb(resultBody).pipe(fileStream);
      fileStream.on('finish', resolve);
      fileStream.on('error', reject);
    });
  }

  return filename;
}

export async function fetchRobot<TResponse>(endpoint: string, method: 'GET' | 'POST', body?: object, headers: Record<string, string> = {}) {
  const result = await fetch(`${process.env.ROBOT_HOST}/${endpoint}`, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(`${process.env.ROBOT_USER}:${process.env.ROBOT_PASSWORD}`)}`,
      ...headers,
    },
    body: JSON.stringify(body),
  });

  if (!result.ok) {
    const error = new Error(`Error while fetching from ROBOT endpoint ${endpoint}. Status: ${result.status} - ${result.statusText}`);
    (error as any).details = await result.text();
    throw error;
  }

  return (await result.json()) as TResponse;
}
